<template>
  <div class="message-template-table">
    <el-table class="mb-x2" :data="templates" stripe @header-click="headerClick">
      <el-table-column label="テンプレート名" sort-by="-name" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="内容" sort-by="-body" :render-header="renderHeader" min-width="45%">
        <template slot-scope="scope">
          <div class="row-body">{{ scope.row.body }}</div>
        </template>
      </el-table-column>
      <el-table-column label="作成日時" sort-by="-created" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">{{ formatDatetime(scope.row.created) }}</template>
      </el-table-column>
      <el-table-column label="更新日時" sort-by="-modified" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">{{ formatDatetime(scope.row.modified) }}</template>
      </el-table-column>
      <el-table-column min-width="10%">
        <template slot-scope="scope">
          <el-tooltip placement="top" content="編集">
            <el-button class="el-button--icon" type="default" @click="openMessageTemplateDialog(scope.row.id)"
              ><i class="mdi mdi-table-edit"></i
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        type="テンプレート"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.message-template-table {
  .row-body {
    height: 70px;
    overflow: hidden;
    white-space: pre-line;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import { formatDatetime } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    Pagination
  },
  props: {
    templates: Array,
    total: Number,
    params: Object,
    options: Object,
    onChangeSortBy: Function,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    openMessageTemplateDialog: Function
  },
  methods: {
    formatDatetime,

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'テンプレート名':
          TrackingService.sendEvent('sort:グループ設定|テンプレート|テンプレート名')
          break
        case '内容':
          TrackingService.sendEvent('sort:グループ設定|テンプレート|内容')
          break
        case '作成日時':
          TrackingService.sendEvent('sort:グループ設定|テンプレート|作成日時')
          break
        case '更新日時':
          TrackingService.sendEvent('sort:グループ設定|テンプレート|更新日時')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    }
  }
})
</script>
